<!-- Page : Lignes budgétaires -->
<div class="lb-page">

  <!-- Header -->
  <header class="lb-page__header">
    <div class="lb-page__header-left">
      <div class="lb-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
        </svg>
      </div>
      <div>
        <h1 class="lb-page__title">Lignes budgétaires</h1>
        <p class="lb-page__desc">Gérez les lignes budgétaires de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter une ligne"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openAddLigneBudgetaireModal()"
    ></app-ui-button>
  </header>

  <!-- Card / Table -->
  <div class="lb-card">
    @if (isLoading) {
      <div class="lb-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="lb-card__toolbar">
        <div class="lb-card__toolbar-left">
          <span class="lb-badge">{{ ligneBudgetaires.length }}</span>
          <span class="lb-card__count">ligne{{ ligneBudgetaires.length > 1 ? 's' : '' }} enregistrée{{ ligneBudgetaires.length > 1 ? 's' : '' }}</span>
        </div>
      </div>

      @if (!ligneBudgetaires.length) {
        <div class="lb-empty">
          <div class="lb-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="6" y1="15" x2="10" y2="15"/>
            </svg>
          </div>
          <p class="lb-empty__title">Aucune ligne budgétaire</p>
          <p class="lb-empty__hint">Commencez par en ajouter une en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table [columns]="tableLigneBudgetaire" [data]="ligneBudgetaires" [actions]="rowActions"/>
      }
    }
  </div>

  <!-- Row actions template -->
  <ng-template #rowActions let-item="item">
    <div class="lb-row-actions">
      <app-ui-button iconOnly="edit" variant="ghost" size="sm" ariaLabel="Modifier" type="button" (clicked)="onEditTask(item)"></app-ui-button>
      <app-ui-button iconOnly="delete" variant="danger" size="sm" ariaLabel="Supprimer" type="button" (clicked)="openDeleteConfirm(item)"></app-ui-button>
    </div>
  </ng-template>

</div>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<!-- Modal Ajout / Edition -->
<app-modal
  [isVisible]="showAddLigneBudgetaireModal"
  [title]="isEditing ? 'Modifier la ligne budgétaire' : 'Nouvelle ligne budgétaire'"
  (closeEvent)="closeAddLigneBudgetaireModal()"
>
  <form [formGroup]="lignebudgetaireForm" (ngSubmit)="saveLigneBudgetaire()" class="lb-form">

    @if (isEditing && editingLigneBudgetaire) {
      <div class="lb-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingLigneBudgetaire.libelle }}</strong>
      </div>
    }

    <div class="lb-form__field">
      <app-input label="Libellé de la ligne budgétaire" placeholder="Ex : Frais de personnel" type="text" formControlName="libelle"/>
      @if (lignebudgetaireForm.get('libelle')?.invalid && (lignebudgetaireForm.get('libelle')?.dirty || lignebudgetaireForm.get('libelle')?.touched)) {
        <span class="lb-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le libellé est requis.
        </span>
      }
    </div>

    <div class="lb-form__actions">
      <app-ui-button label="Annuler" variant="ghost" size="md" type="button" (clicked)="closeAddLigneBudgetaireModal()"></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary"
        size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || lignebudgetaireForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>